import { useTourGamesAdmin } from './useTourGamesAdmin';
export default useTourGamesAdmin;
